<template>
    <div class="list-outside-container d-flex flex-column justify-space-between align-center">
        <div class="label-container">
            <label>{{ $t('provider_config.area_list') }}</label>        
        </div> 
        <div>
            <v-btn @click="backPage" :disabled='this.page === 1' :loading='loading' icon> <v-icon>mdi-chevron-left</v-icon></v-btn>
            <v-chip outlined> {{ this.page }} - {{ this.totalPages }} </v-chip>
            <v-btn @click="nextPage" :disabled='this.page === this.totalPages' :loading='loading' icon> <v-icon>mdi-chevron-right</v-icon></v-btn>
        </div>
        <perfect-scrollbar class="list-inner-container">
            <v-list v-if="areas">
                <v-list-item v-for="area in areas" :key="area._id">
                    <AreaListItem class="area-item-list" @clickedOnList='clickedRefs($event)' :area="area"></AreaListItem>
                </v-list-item>
            </v-list>
        </perfect-scrollbar>
    </div>
</template>

<script>
	import AreaListItem from './AreaListItem';
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import { GET_POLYS, SET_MAPPAGE } from '../../../store/mutations';

	export default {
        name: 'AreaList',
        
        components: { AreaListItem },

        props: ['totalPages'],

        data() {
            return {
                loading: false,
            }
        },

        computed: {
                ...mapGetters({ areas: 'AreaVuex/areas', getProvider: `ProviderVuex/provider`, page: 'AreaVuex/mapPage' }),

        },

        methods: {

            ...mapActions({ getAreas: `AreaVuex/${GET_POLYS}` }),

            ...mapMutations({ setPage: `AreaVuex/${SET_MAPPAGE}`}),
            
            async backPage() {

                this.loading = true

                const newPage = this.page - 1

                await this.updatePage(newPage)
       
                await this.getAreas({page: this.page, id: this.getProvider._id})

                this.loading = false 


            },

            async nextPage() {

                this.loading = true

                const newPage = this.page + 1

                await this.updatePage(newPage)
            
                await this.getAreas({page: this.page, id: this.getProvider._id})

                this.loading = false 

            },

            async updatePage(newPage) {

                await this.setPage(newPage)


            },

            clickedRefs(refs) {

                this.$emit('changeAreaColor', refs)


            }


        },

	};
</script>

<style scoped>
    .list-outside-container {
        max-height: 100%;
        width: 100%;

    }

    .list-inner-container {
        width: 100%;
        margin: 0.5em 0;
        overflow: hidden;
    }

    .label-container {
        text-align: center;
        margin: 1em 1em 0;
    }

    .label-container label {
        font-weight: bold;
    }
</style>
